module.exports = __webpack_public_path__ + "img/howit-first-new.6aafb4f1.svg";